import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-brown/20 bg-bg-secondary/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-259" data-mp="2nvdkvhbbap68">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-260" data-mp="2wvagy4016qbb">
        <div data-id="element-261" data-mp="2sxcpsvmp9u5a">
          <p className="font-heading text-sm font-bold text-ink" data-id="element-262" data-mp="2sxmgklfkk5c1">19€</p>
          <p className="text-[11px] text-muted" data-id="element-263" data-mp="o1mkx9vfs1b3">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} data-id="element-264" data-mp="s1enn5y5fd8j">
          Quiero el Kit
        </PrimaryButton>
      </div>
    </div>;
}